/**
 * Root reducer.
 * @module reducers/root
 */

import defaultReducers from 'design-comuni-plone-theme/reducers';
import {
  searchEventsHeadquarters,
  searchEventsKeywords,
  searchEventsLocations,
  searchEventsMode,
  searchEventsTopics,
} from './eventsSearchBlock';
/**
 * Root reducer.
 * @function
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
const reducers = {
  ...defaultReducers,
  searchEventsLocations,
  searchEventsKeywords,
  searchEventsHeadquarters,
  searchEventsMode,
  searchEventsTopics,
};

export default reducers;
